import { Component, computed, input } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import { type Step, StepsComponent } from '@content/ui/steps';
import { type ComponentRendering, LinkField, TextField } from '@core/jss-proxy';
import {
  getField,
  getItemLinkFieldValue,
  getTreelistEntries,
} from '@core/jss-utils';
import {
  computedContentSectionId,
  computedContentSectionTheme,
  ContentSectionComponent,
} from '@core/content-section';

@Component({
  selector: 'wl-steps-section-container',
  standalone: true,
  templateUrl: './steps-section.container.component.html',
  imports: [StepsComponent, ContentSectionComponent],
})
export class StepsSectionContainerComponent {
  readonly rendering = input.required<InnogyComponentRendering>();
  readonly id = computedContentSectionId(this.rendering);
  readonly theme = computedContentSectionTheme(this.rendering);

  readonly fields = computed(() => this.rendering().fields);

  readonly headingField = computed(() =>
    getField<TextField>(this.fields(), 'Title')
  );

  readonly steps = computed(() => {
    return getTreelistEntries(this.fields(), 'Steps', []).map((step) =>
      this.getCard(step)
    );
  });

  getCard(rendering: ComponentRendering) {
    return {
      explanation: getField<TextField>(rendering.fields, 'Explanation'),
      icon: getItemLinkFieldValue(rendering.fields, 'Icon'),
    } as Step;
  }

  readonly button = computed(() =>
    getField<LinkField>(this.fields(), 'CallToAction')
  );
}
